import { EMPTY_LIST_OPTION } from '@/constants'
import EmptyList from '@/components/EmptyList'

interface Props {
  account_wax: string | null
}

const EmptyUserInventory = ({ account_wax }: Props) => {
  const type: EMPTY_LIST_OPTION = account_wax ? 'All' : 'noAddress'
  return <EmptyList type={type} />
}

export default EmptyUserInventory
